import { TABLENAMES } from "src/global";
import fs from "src/services/config/fbConfig";
import { IProjectService } from "./interfaces";

export default class ProjectService implements IProjectService {
  constructor() {
    this.isProjectActive = this.isProjectActive.bind(this);
    this.isProjectIdActive = this.isProjectIdActive.bind(this);
    this.setActiveProject = this.setActiveProject.bind(this);
    this.resetActiveProject = this.resetActiveProject.bind(this);
    this.getActiveProjectId = this.getActiveProjectId.bind(this);
    this.getActiveProjectLocation = this.getActiveProjectLocation.bind(this);
  }

  public isProjectActive(): boolean {
    return this.getActiveProjectId() !== "";
  }
  public isProjectIdActive(id: string): boolean {
    return this.getActiveProjectId() === id;
  }
  public setActiveProject(id: string, projectLocation: string): void {
    sessionStorage.setItem("projectId", id);
    sessionStorage.setItem("projectLocation", projectLocation);
  }
  public resetActiveProject(): void {
    sessionStorage.removeItem("projectId");
    sessionStorage.removeItem("projectLocation");
  }
  public getActiveProjectId(): string {
    const id = sessionStorage.getItem("projectId");
    if (id) {
      return id;
    }
    return "";
  }
  public getActiveProjectLocation(): string {
    const projectLocation = sessionStorage.getItem("projectLocation");
    if (projectLocation) {
      return projectLocation;
    }
    return "";
  }
  public copyProject(sourceId: string, id: string): void {
    const sourceProjectDoc = fs.fs.collection("projects").doc(sourceId);
    const projectDoc = fs.fs.collection("projects").doc(id);
    const guaranteedPowerTable = sourceProjectDoc.collection(TABLENAMES.GUARANTEEDPOWERTABLE);

    sourceProjectDoc.get().then(doc => {
      if (doc.exists) {
        const data = doc.data();
        if (data) {
          const location = data.location;
          projectDoc
            .set(data)
            .then(() => {
              projectDoc.update({
                timestamp: Date.now(),
                location: "Copy of " + location,
              });
            })
            .then(() => {
              this.copyStatements(sourceProjectDoc, projectDoc);
            })
            .then(() => {
              guaranteedPowerTable.get().then(querySnapshot => {
                querySnapshot.forEach(doc => {
                  if (doc.exists) {
                    projectDoc.collection(TABLENAMES.GUARANTEEDPOWERTABLE).add(doc.data());
                  }
                });
              });
            });
        }
      }
    });
  }
  private copyStatements(
    sourceProjectDoc: firebase.firestore.DocumentReference,
    projectDoc: firebase.firestore.DocumentReference
  ): void {
    const statements = sourceProjectDoc.collection(TABLENAMES.STATEMENTS);
    const simpleSingleRateStatements = sourceProjectDoc.collection(
      TABLENAMES.SIMPLESINGLERATESTATEMENTS
    );
    const simpleDualRateStatements = sourceProjectDoc.collection(
      TABLENAMES.SIMPLEDUALRATESTATEMENTS
    );
    const advancedSingleRateStatements = sourceProjectDoc.collection(
      TABLENAMES.ADVANCEDSINGLERATESTATEMENTS
    );
    const advancedDualRateStatements = sourceProjectDoc.collection(
      TABLENAMES.ADVANCEDDUALRATESTATEMENTS
    );
    statements.get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        if (doc.exists) {
          projectDoc
            .collection(TABLENAMES.STATEMENTS)
            .add(doc.data())
            .then(newStatement => {
              simpleSingleRateStatements
                .get()
                .then(querySnapshot => {
                  querySnapshot.forEach(doc => {
                    if (doc.exists) {
                      projectDoc
                        .collection(TABLENAMES.SIMPLESINGLERATESTATEMENTS)
                        .doc(newStatement.id)
                        .set(doc.data());
                    }
                  });
                })
                .then(() => {
                  simpleDualRateStatements
                    .doc(doc.id)
                    .get()
                    .then(doc => {
                      if (doc.exists) {
                        const data = doc.data();
                        if (data) {
                          projectDoc
                            .collection(TABLENAMES.SIMPLEDUALRATESTATEMENTS)
                            .doc(newStatement.id)
                            .set(data);
                        }
                      }
                    });
                })
                .then(() => {
                  advancedSingleRateStatements
                    .doc(doc.id)
                    .get()
                    .then(doc => {
                      if (doc.exists) {
                        const data = doc.data();
                        if (data) {
                          projectDoc
                            .collection(TABLENAMES.ADVANCEDSINGLERATESTATEMENTS)
                            .doc(newStatement.id)
                            .set(data)
                            .then(() => {
                              const source = advancedSingleRateStatements.doc(doc.id);
                              const sourceCollection = source.collection(TABLENAMES.SERVICECHARGES);
                              const statement = projectDoc
                                .collection(TABLENAMES.ADVANCEDSINGLERATESTATEMENTS)
                                .doc(newStatement.id);
                              const collection = statement.collection(TABLENAMES.SERVICECHARGES);
                              this.copyCollection(sourceCollection, collection);
                            });
                        }
                      }
                    });
                })
                .then(() => {
                  advancedDualRateStatements
                    .doc(doc.id)
                    .get()
                    .then(doc => {
                      if (doc.exists) {
                        const data = doc.data();
                        if (data) {
                          projectDoc
                            .collection(TABLENAMES.ADVANCEDDUALRATESTATEMENTS)
                            .doc(newStatement.id)
                            .set(data)
                            .then(() => {
                              const source = advancedDualRateStatements.doc(doc.id);
                              const statement = projectDoc
                                .collection(TABLENAMES.ADVANCEDDUALRATESTATEMENTS)
                                .doc(newStatement.id);

                              // Copy service charges
                              let sourceCollection = source.collection(TABLENAMES.SERVICECHARGES);
                              let collection = statement.collection(TABLENAMES.SERVICECHARGES);
                              this.copyCollection(sourceCollection, collection);

                              // Copy taxes and fees
                              sourceCollection = source.collection(TABLENAMES.TAXESANDFEES);
                              collection = statement.collection(TABLENAMES.TAXESANDFEES);
                              this.copyCollection(sourceCollection, collection);
                            });
                        }
                      }
                    });
                });
            });
        }
      });
    });
  }
  private copyCollection(
    sourceCollection: firebase.firestore.CollectionReference,
    collection: firebase.firestore.CollectionReference
  ): void {
    sourceCollection.get().then(querySnapshot => {
      querySnapshot.forEach(doc => {
        if (doc.exists) {
          collection.add(doc.data());
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/project/projectService.tsx